import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MlModel } from '../../models/mlmodel/mlModel.model';
import { GlobalService } from '../../services/global.service';
import { MLService } from '../../services/ml-service';
import { NgForm, UntypedFormGroup } from '@angular/forms';
import { WorkflowService } from '../../services/workflow-service';
import { PlatformComponent } from '../../models/workflow/Model.model';
import { WorkflowEventsHandler } from '../../workflow/workflow-events/workflow.events.handler';
import { AlertComponent } from '../../common/alert/alert.component';
import { monitorElement, dataSource, criteriaType } from '../../models/workflow/monitoring.model';
import { gapElement, duration } from '../../models/workflow/gapAnalysis.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ConfirmModelComponent } from '../../common/confirm-model/confirm-model.component';

@Component({
  selector: 'app-std-component-manager',
  templateUrl: './std-comp-mngr.component.html',
  styleUrls: ['./std-comp-mngr.component.css']
})

export class StdComponentManagerComponent implements OnInit {
  platformComponent: PlatformComponent = new PlatformComponent();
  srcConnParameterList = [];
  sinkConnParameterList = [];
  sinkModel = new MlModel();
  srcConnVariablesList = [];
  dataToPass = [];
  userSinkVar = false;
  form_template = [];
  @ViewChild('f', { static: true }) registerForm: NgForm;
  myFormGroup: UntypedFormGroup;
  readOnly: false;
  isLoading = false;
  dataSource: any[];
  dataSourceSelected;
  dataSourceName;
  selectedParameter;
  dataMonitoringList;
  dataMonitoringListModified;
  durationData: duration[] = [];
  datasource: dataSource[] = [];
  criteriaTypeData: criteriaType[] = [];
  selectedMonitoringElement: monitorElement = new monitorElement();
  dataGapList;
  selectedGapElement: gapElement[] = [];
  parameterSelected= false;
  dataListDetails: MatTableDataSource<any>;
  modelErrorMessage: string = "";
  displayedMonitorColumns: string[] = ['Add', 'dataSource', 'parameterName', 'criteriaType', 'condition', 'value', 'frequency'];
  displayedGapColumns: string[] = ['Add', 'measuredData', 'referenceData', 'duration'];
  branching = false;
  isBranching = false;
  dropdownList = [];
  trueBranches = [];
  falseBranches = [];
  dropdownSettings: IDropdownSettings = {};
  branchigStep = false;
  monitoringComponentName: string;
  selectedBranches = [];
  selectCollection: boolean = false;
  collectionsList;

  constructor(public dialogRef: MatDialogRef<StdComponentManagerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: GlobalService,
    public mlService: MLService,
    public workflowService: WorkflowService,
    public workflowHandler: WorkflowEventsHandler,
    public dialog: MatDialog) {
  };

  ngOnInit() {
    this.isLoading = true;
    this.dialogRef.disableClose = true;
    this.monitoringComponentName = this.globals.monitoringComponentName;
    this.platformComponent = this.data.component;
    this.trueBranches = this.data.component.isBranchingTrue;
    this.falseBranches = this.data.component.isBranchingFalse;
    if (this.platformComponent.componentName == this.monitoringComponentName) {
      this.selectedMonitoringElement.parameterName = this.data.component.componentDetails.name;
      this.selectedMonitoringElement.tagThresholdMappingId = this.data.component.componentDetails.id;
      this.selectCollection = this.data.component.componentDetails.selectCollection;
      this.selectedParameter = this.platformComponent.componentDetails.name;
      this.getDataList(this.platformComponent.componentName);
      this.getDataSource();
      this.getCriteriaList();
    } else {
      this.selectCollection = this.data.component.componentDetails.selectCollection;
      this.selectedParameter = this.platformComponent.componentDetails.name;
      this.getDataList(this.platformComponent.componentName);
      this.getDuration();
    }
    this.readOnly = this.data.readOnly;
    if (this.data.context.outgoing) {
      this.isBranching = this.data.context.outgoing.length > 1;
    }
    if (this.isBranching) {
      this.dropdownList = this.modefiedList(this.data.context.outgoing);
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'name',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 2,
        allowSearchFilter: false
      };
    }
  }

  modefiedList(dataset) {
    let modefiedList: any = [];
    const listDataModel = dataset;
    for (let i = 0; i < listDataModel.length; i++) {
      modefiedList.push({
        'name': listDataModel[i].targetRef.$attrs.componentUniqueId
      });
    }
    return modefiedList;
  }

  branchingStep() {
    this.branchigStep = !this.branchigStep;
  }

  getDuration() {
    this.workflowService.getDuration().subscribe((data: any): void => {
      this.durationData = data;
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in getting duration data" });
      this.isLoading = false;
    });
  }

  getDataSource() {
    this.workflowService.getDataSource().subscribe((data: any): void => {
      this.datasource = data;
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in getting data source data" });
      this.isLoading = false;
    });
  }

  getCriteriaList() {
    this.workflowService.getCriteriaType().subscribe((data: any): void => {
      this.criteriaTypeData = data;
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in getting criteria type data" });
      this.isLoading = false;
    });
  }

  getDataList(componentName) {
    if (this.selectCollection) {
      this.workflowService.getCollectionListDetails(componentName).subscribe((data: any): void => {
        this.collectionsList = data;
        this.loadDataInTable();
        this.isLoading = false;
      }, (error: Error) => {
        this.globals.showAlert(AlertComponent, { success: false, message: "Error in getting " + componentName + " data" });
        this.isLoading = false;
      });
    }
    this.workflowService.getDataListDetails(componentName).subscribe((data: any): void => {
      if (componentName == this.monitoringComponentName) {
        this.dataMonitoringList = data;
        this.dataMonitoringListModified = [...data];
        this.dataMonitoringListModified = this.dataMonitoringListModified.filter((test, index, array) =>
          index == array.findIndex((findTest) =>
            findTest.parameterName == test.parameterName
          ));
      } else {
        this.dataGapList = data;
      }
      this.loadDataInTable();
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in getting " + componentName + " data" });
      this.isLoading = false;
    });
       
  }

  loadDataInTable() {
    if (this.platformComponent.componentDetails && this.platformComponent.componentDetails.name.length > 0) {
      this.parameterSelected = true;
      this.onSelectParameter(this.platformComponent.componentDetails.name, this.platformComponent.componentDetails.id);
    }
  }

  onSelectParameter(parameter, id?) {
    this.dataListDetails = new MatTableDataSource(this.dataSource);
    if (this.platformComponent.componentName == this.monitoringComponentName) {
      if (this.selectCollection) {
        this.parameterSelected = true;
        this.dataListDetails = new MatTableDataSource((this.collectionsList.find(coll => coll.collectionId == id)).criterias);
        this.data.component.componentDetails.name = (this.collectionsList.find(coll => coll.collectionId == id)).collectionName;
        this.data.component.componentDetails.id = id;
      } else {
        this.dataListDetails = new MatTableDataSource(this.dataMonitoringList);
        this.dataListDetails.filter = parameter.trim().toLowerCase();
      }
    } 
    else if (this.selectCollection) {
      this.parameterSelected = true;
      if (this.dataGapList) {
        this.dataListDetails = new MatTableDataSource(this.dataGapList.filter(coll => coll.collectionId == id));
      }
      if (this.dataGapList.find(coll => coll.collectionId == id)) {
        this.data.component.componentDetails.name = (this.dataGapList.find(coll => coll.collectionId == id)).collectionName;
      } else {
        this.data.component.componentDetails.name = "";
      }
      this.data.component.componentDetails.id = id;
      this.dataListDetails.filter = parameter.trim().toLowerCase();
    }
    else {
      this.selectedGapElement = this.dataGapList.filter(g => g.id == id)[0];
      this.parameterSelected = true;
      this.dataListDetails = new MatTableDataSource(this.dataGapList);
      this.dataListDetails.filter = parameter.trim().toLowerCase();
    }
  }

  radioChange(event ) {
    this.parameterSelected = event;
  }

  saveMonitorDetails(selectedMonitoringElement: monitorElement) {
    const mergedArray = [...this.trueBranches, ...this.falseBranches];
    // mergedArray have duplicates, lets remove the duplicates using Set
    let set = new Set();
    this.selectedBranches = mergedArray.filter(item => {
      if (!set.has(item.name)) {
        set.add(item.name);
        return true;
      }
      return false;
    }, set);
    if (this.selectedBranches.length < this.dropdownList.length) {
      let dataToPass = {
        title: 'Confirm',
        isDelete: false,
        message: 'Few branches will not execute in any case, do yo wish to continue?'
      };
      this.globals.openModelWindow(this.saveOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
    }

    else {
      this.saveOnConfirm(this);
    }
  }

  saveOnConfirm(thisRef: StdComponentManagerComponent) {
    thisRef.data.component.isBranchingTrue = thisRef.trueBranches;
    thisRef.data.component.isBranchingFalse = thisRef.falseBranches;
    thisRef.data.component.componentDetails.selectCollection = thisRef.selectCollection;
    if (!thisRef.selectCollection) {
      thisRef.data.component.componentDetails.name = thisRef.selectedMonitoringElement.parameterName;
      thisRef.data.component.componentDetails.id = thisRef.selectedMonitoringElement.tagThresholdMappingId;
    }
    thisRef.dialogRef.close(false);
  }

  saveGapDetails(selectedGapElement: gapElement) {
    this.data.component.componentDetails.selectCollection = this.selectCollection;
    if (!this.selectCollection) {
      this.data.component.componentDetails.name = selectedGapElement.gapConfigurationName;
      this.data.component.componentDetails.id = selectedGapElement.id;
    }
    this.dialogRef.close(false);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  changeSelection() {
    this.selectedParameter = "";
    this.platformComponent.componentDetails.name = "";
    this.getDataList(this.platformComponent.componentName);
    this.dataListDetails = new MatTableDataSource([]);
  }

  disableSavebutton() {
    let check: boolean = !this.parameterSelected || this.readOnly || (this.branchigStep && (this.trueBranches.length == 0 && this.falseBranches.length == 0))
      || !this.globals.isNotNull(this.selectedParameter);
    return check;
  }

}
